/**
 * Fallback author for the blog byline only when ACF blogPostEn.authorShown is null/empty.
 * The byline always prefers ACF authorShown (Select, Return Label); this is used only as backup.
 */
export const DEFAULT_BLOG_AUTHOR = 'Sami Suo-Heikki';

/**
 * Map partial/first-name author values to full "Etunimi Sukunimi" for consistent display in list and post.
 * Keys: value from WordPress/ACF (e.g. first name only). Value: display name shown to user.
 */
export const BLOG_AUTHOR_FULL_NAMES = {
  Sami: 'Sami Suo-Heikki',
  Reetta: 'Reetta Hill',
};

/** Default CTA when ACF blog post CTA fields are empty (before footer). */
export const CTA_DEFAULTS = {
  title: 'Interested in learning more?',
  description: "Let's discuss how we can help with your next project.",
  buttonText: 'Talk to Our Team',
  buttonUrl: '/contact',
};

/** Finnish default CTA for blog post template (lang === 'fi'). */
export const CTA_DEFAULTS_FI = {
  title: 'Haluatko tietää lisää?',
  description: 'Keskustellaan, miten voimme auttaa seuraavassa projektissasi.',
  buttonText: 'Ota yhteyttä',
  buttonUrl: '/yhteys',
};
